import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '@/features/marketing/components/marketing-page'
import { enContent } from '@/features/marketing/content'

export const Route = createFileRoute('/en/')({
  component: EnHomePage,
})

function EnHomePage() {
  return <MarketingPage {...enContent.home} />
}
